export const textde = {
  titleHome: 'Visit Bröllin (Vorschau {version})',
  welcome: 'Herzlich Willkommen in Bröllin!',
  qrInfo:
    'Mit dem Button <img src="{qrIcon}" style="height: 1em" /> oben in der Mitte kannst du die QR-Codes an den Gebäuden auf dem Gelände des Schloss Bröllins scannen und erhältst weitere Informationen.',
  mapAlt: 'Lageplan Bröllin',
  logoAlt: 'Logo',
  homeAlt: 'Startseite',
  backAlt: 'Zurück',
  qrAlt: 'QR-Code',
  qrScan: 'QR-Code scannen',
  langSelectTitle: 'Sprache wählen',
  langDe: 'Deutsch',
  langEn: 'English',
  langPl: 'Polski',
  close: 'Schließen',
  navHome: 'Startseite',
  navMenu: 'Menü',
  navStudio3: 'Studio 3',
  navStudio1: 'Studio 1',
  navStudio2: 'Studio 2',
  navMeadow: 'Wiese',
  navSheepStable: 'Schafstall',
  navManor: 'Gutshaus',
  navCircusSilo: 'Circussilo, Speicher-Querbau',
  navCafe: 'Café',
  navRefectorium: 'Refektorium, Speicher-Langbau',
  navFlorianHall: 'Florian-Vogelfrei-Halle, Korntrocknungshalle',
  navPolishGerman: 'Deutsch-Polnisches, Großer Bullenstall',
  switchToLight: 'Zum hellen Design wechseln',
  switchToDark: 'Zum dunklen Design wechseln',
  themeAuto: 'System-Einstellung folgen (automatisch)',
  navAbout: 'Über uns',
  aboutTitle: 'Weitere Links',
  aboutLinkWebsite: 'Webseite broellin.de',
  aboutApp: 'Diese App https://brollin.sonabit.de',
  aboutQrAlt: 'QR-Code für brollin.sonabit.de',
  aboutVersion: 'Version: {version}',
  noCodeProvided: 'Kein Code angegeben.',
  noContentFound: 'Kein Inhalt für Code "{code}" in Sprache "{lang}" gefunden.',
  noContentFoundGeneric: 'Kein Inhalt für Code "{code}" gefunden.',
  homeText:
    'Die Anfänge des Rittergutes gehen auf das 13. Jahrhundert zurück, im Jahre 1850 kaufte die Familie Stöwahs Bröllin und baute es zu einem seinerzeit sehr modernen Betrieb mit 350 Hektar Land um. Die Familie wurde nach dem zweiten Weltkrieg im Zuge der Bodenreform enteignet und eine LPG gegründet. Nach der Abwicklung der LPG mietete sich das R.A.M.M.- Theater aus Berlin auf der Suche nach einem Produktionsort auf dem Gelände ein, im Jahre 1992 wurde schloss bröllin e.V. gegründet, der den Gutshof von der Treuhand kaufte und hier seitdem einen internationalen Residenzort für darstellende Kunst betreibt.',
}
